<template>
  <div>
    พิมพ์รายการสั่งซื้อ
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>

</style>
